import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";
import { DeleteLessonModal } from "../DeleteVideoModal";
import { EditLessonModal } from "../EditLessonModal";
import { useNavigate } from "react-router-dom";

export function LessonActionCell(props) {
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  return (
    <SoftBox display="flex" alignItems="center">
      <EditLessonModal open={openEditModal} course={props.course} lesson={props.lesson} onClose={() => setOpenEditModal(false)} />
      <DeleteLessonModal open={openDeleteModal} course={props.course} lesson={props.lesson} onClose={() => setOpenDeleteModal(false)} />
      <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={() => {
        navigate("/admin/courses/all/edit/" + props.course.id + "/lesson/" + props.lesson.id)
      }}>
        <Tooltip title="Preview Lesson" placement="top">
          <Icon>visibility</Icon>
        </Tooltip>
      </SoftTypography>
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={() => setOpenEditModal(true)}>
          <Tooltip title="Edit Lesson" placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={() => setOpenDeleteModal(true)}>
        <Tooltip title="Delete Lesson" placement="left">
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );
}

LessonActionCell.propTypes = {
  course: PropTypes.any.isRequired,
  lesson: PropTypes.any.isRequired,
};